import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/src/app/not-found.tsx");
